/**
 * @file 弹窗埋点统计
 * @link https://docs.google.com/spreadsheets/d/1qUD7k3Dl3FuU_cswVMeaYwIC1efNul1nAIbUswa-1yA/edit#gid=1469618169
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IStatLogParams {
    page_type: number;
    action_type: string;
}

export const setStatLogDialogs = (params: IStatLogParams) => {
    return fetchData(Api.STAT_LOG_DIALOG, params, { silent: true });
};
